export default __webpack_public_path__ + "static/media/misc-books1-2048w.601c55eb.avif";